import { makeStyles } from '@material-ui/styles';
import { format, utcToZonedTime } from 'date-fns-tz';
import clsx from 'clsx';
import { useAtomValue } from 'jotai';

import { Text } from '@bizzabo/design-system';

import { formatRelativeToToday } from './helpers';
import currentTimeZoneIdAtom from '../../timeZoneId';

interface DateAndTimeProps {
    startDate: Date;
    endDate: Date;
    isNowShow?: boolean;
}

const DateAndTime: React.FC<DateAndTimeProps> = ({ startDate, endDate, isNowShow }) => {
    const classes = useStyles();
    const currentTimeZoneId = useAtomValue(currentTimeZoneIdAtom);

    if (!startDate || !endDate) {
        return null;
    }

    const now = new Date();
    const isHappeningNow = startDate <= now && endDate >= now;

    const relativeTimeText = isHappeningNow && isNowShow ? 'Now' : formatRelativeToToday(startDate);

    const timeFromFormat = relativeTimeText ? 'MMM. d | h:mm' : 'EEEE, MMM. d | h:mm';
    const timeFrom = format(utcToZonedTime(startDate, currentTimeZoneId), timeFromFormat);
    const timeTo = format(utcToZonedTime(endDate, currentTimeZoneId), 'h:mmaaa');

    return (
        <Text variant="t81" className={classes.text}>
            {relativeTimeText && (
                <span className={clsx({ [classes.now]: isHappeningNow })}>
                    {`${relativeTimeText}, `}
                </span>
            )}
            {`${timeFrom}-${timeTo} | `}
        </Text>
    );
};

const useStyles = makeStyles(
    theme => ({
        text: {
            marginRight: 4,
        },
        now: {
            color: theme.palette.notification,
        },
    }),
    { classNamePrefix: 'meetings-date-time' }
);

export default DateAndTime;
